exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.success_email_img[data-v-0cf381f3] {\n    max-width: 150px;\n    width: 100%;\n}\n.show-check-email-message[data-v-0cf381f3] br {\n        display: inline;\n}\n@media screen and (max-width: 767px) {\n.show-check-email-message[data-v-0cf381f3] {\n        text-align: left;\n}\n.show-check-email-message[data-v-0cf381f3] br {\n        display: none;\n}\n}\n", ""]);

// exports
